module.exports = {"TITLE":"Survey Results","QUESTION":"Questions","RESULT":"Results"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/en/surveys.json
// module id = 422
// module chunks = 8